import { useQuery } from "@tanstack/react-query";
import { getClient } from "../services/api";
import { Client } from "@/types/api";

export const useClient = (clientId: string) => {
  const { data: client, isLoading: isLoadingClient, error: clientError } = useQuery<Client>({
    queryKey: ["client", clientId],
    queryFn: () => getClient(clientId),
    enabled: Boolean(clientId),
    staleTime: 0,
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  return {
    client,
    isLoadingClient,
    clientError,
  };
};